<template>
  <button
    type="button"
    class="bet-triple-combo-btn"
    :class="{
      'bet-triple-combo-btn--selected': selected,
      'bet-triple-combo-btn--mirrored': mirrored,
      'bet-triple-combo-btn--result-matched': resultMatched,
    }"
    :aria-label="`Triple ${face}-${face}-${face}`"
    @click="$emit('click')"
  >
    <span v-if="mirrored" class="bet-triple-combo-btn__odds">{{ odds }}</span>
    <span class="bet-triple-combo-btn__dice-group">
      <img v-for="index in 3" :key="index" :src="diceImage(face)" alt="" />
    </span>
    <span v-if="!mirrored" class="bet-triple-combo-btn__odds">{{ odds }}</span>
    <BetPlacedChip
      v-if="amount"
      :amount="amount"
      :chips="chips"
      placement="top-right"
      overlap
    />
  </button>
</template>

<script>
import BetPlacedChip from '@/components/tai-xiu/bet-placed-chip.vue';

export default {
  components: {
    BetPlacedChip,
  },
  props: {
    face: {
      type: Number,
      required: true,
    },
    odds: {
      type: String,
      default: '1 : 120',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    resultMatched: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: Number,
      default: 0,
    },
    chips: {
      type: Array,
      default: () => [],
    },
    mirrored: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    diceImage(face) {
      return require(`@/assets/svg/dice-items/dice-${face}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins/_tx-result-border.scss';

.bet-triple-combo-btn {
  position: relative;
  overflow: visible;
  min-height: 0;
  height: 100%;
  padding: 2px 4px;
  border: 1px solid #372F4A;

  // border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // gap: 3px;
  cursor: pointer;
  color: #dac9de;
  background: #1C1824;
  box-sizing: border-box;
  overflow: hidden;

  &--mirrored {
    flex-direction: row;
  }

  &--selected {
    border-color: #573a89;
    box-shadow: none;
    background: linear-gradient(to bottom, #614596, rgba(67, 50, 98, 0.4));
    color: white;
  }

  &--result-matched {
    @include tx-result-matched-border;
  }
}

.bet-triple-combo-btn__dice-group {
  display: flex;
  align-items: center;
  gap: 2px;

  img {
    width: 16px;
    height: 16px;
    display: block;
    flex-shrink: 0;
  }
}

.bet-triple-combo-btn__odds {
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

// The middle column of the full board gets very tight on small handsets, where
// the dice row and the odds would otherwise be clipped by the button.
@media screen and (max-width: 400px) {
  .bet-triple-combo-btn {
    padding: 2px 3px;
    gap: 2px;
  }

  .bet-triple-combo-btn__dice-group {
    gap: 1px;

    img {
      width: 12px;
      height: 12px;
    }
  }

  .bet-triple-combo-btn__odds {
    font-size: 8px;
  }
}

@media screen and (max-width: 360px) {
  .bet-triple-combo-btn__dice-group img {
    width: 10px;
    height: 10px;
  }

  .bet-triple-combo-btn__odds {
    font-size: 7px;
  }
}
</style>
